export enum MapModeEventTypeEnum {
  Activated,
  Data,
  Deactivated
}
